import React, { Fragment } from 'react'
import { Modal, modalVisibility, openModal, ModalVisibilityProps } from 'sb-modal'

import messages from './messages'
import s from './SomethingWentWrongModal.scss'


type Props = {
  hideIcon?: boolean
  error?: any
}

type SomethingWentWrongModalProps = ModalVisibilityProps & Props

const SomethingWentWrongModal: React.FunctionComponent<SomethingWentWrongModalProps> = (props) => {
  const { hideIcon, error, closeModal, onClose } = props

  return (
    <Modal
      iconName={hideIcon ? null : 'sadBird'}
      title={messages.title}
      text={messages.text}
      primaryButton={{
        title: messages.buttonTitle,
        onClick: () => {
          closeModal()
        },
      }}
      onClose={onClose}
    >
      {
        Boolean(error) && (
          <div className={s.error}>
            {JSON.stringify(error)}
            {
              Boolean(error.message || error.stack) && (
                <Fragment>
                  <br />
                  <br />
                </Fragment>
              )
            }
            {
              Boolean(error.message) && (
                <Fragment>
                  <b>Error message:</b>
                  <br />
                  {error.message}
                </Fragment>
              )
            }
            {
              Boolean(error.stack) && (
                <Fragment>
                  <b>Error stack:</b>
                  <br />
                  {error.stack}
                </Fragment>
              )
            }
          </div>
        )
      }
    </Modal>
  )
}

export const openSomethingWentWrongModal = (props: Props) => openModal('somethingWentWrong', props)


export default modalVisibility('somethingWentWrong', SomethingWentWrongModal)
